module.exports = __webpack_public_path__ + "static/img/GettyImages-575131345.bd8a9f4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/company-performance/GettyImages-575131345.jpg
// module id = 16lt
// module chunks = 0